import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/category", label: "影视分类" },
  { to: "/search", label: "搜索" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSearch = (value: string) => {
    const q = value.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  const submit = (e: FormEvent) => {
    e.preventDefault();
    handleSearch(keyword);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:h-[68px] md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-line text-xl leading-none"></i>
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            看片网站
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={submit} className="ml-auto hidden w-full max-w-xs items-center gap-2 md:flex lg:max-w-sm">
          <div className="relative w-full">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              type="text"
              placeholder="搜索电影、电视剧名称"
              className="w-full rounded-md border border-background-300/70 bg-background-50 py-2 pl-9 pr-3 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 md:hidden"
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl leading-none`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-4 md:hidden">
          <form onSubmit={submit} className="mb-4 flex items-center gap-2">
            <div className="relative w-full">
              <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-base text-foreground-400"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                type="text"
                placeholder="搜索电影、电视剧名称"
                className="w-full rounded-md border border-background-300/70 bg-background-50 py-2.5 pl-9 pr-3 text-sm outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `flex items-center gap-3 rounded-md px-3 py-3 text-sm font-medium ${
                    isActive ? "bg-primary-50 text-primary-700" : "text-foreground-800"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}